module.exports = __webpack_public_path__ + "img/line.5a76efcf.svg";